'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestBaseClass = function () {
    /**
     * Requeststring (z.B./Streets?city=" + city)
     * @type {string}
     */
    //request
    /**
     * Ist Aufruf asynchron (Standart = true)
     * @type {boolean}
     */
    //async
    /**
     * Callback nach erfolgreichem Request
     * @type {function}
     */
    //readyCallback
    /**
     * Fehlerbehandlung nach fehlgeschlagenem Request
     * @type {Function}
     */
    //errorHandler

    function RequestBaseClass(request) {
        _classCallCheck(this, RequestBaseClass);

        this.request = request;
        this.async = true;
        this.readyCallback = null;
        this.errorHandler = null;
        this.errorHandlingPage = null;
    }

    _createClass(RequestBaseClass, [{
        key: 'setRequest',
        value: function setRequest(request) {
            this.request = request;
        }
    }, {
        key: 'setAsync',
        value: function setAsync(async) {
            this.async = async;
        }
    }, {
        key: 'setErrorHandler',
        value: function setErrorHandler(error) {
            this.errorHandler = error;
        }
    }, {
        key: 'setCallback',
        value: function setCallback(callBack) {
            this.readyCallback = callBack;
        }
    }, {
        key: 'setErrorHandlingPage',
        value: function setErrorHandlingPage(errorHandling) {
            if (typeof errorHandling === 'function') {
                this.errorHandlingPage = errorHandling;
            }
        }
    }]);

    return RequestBaseClass;
}();

exports.default = RequestBaseClass;